import React from 'react';

import CmsPageCards, { CMS2_PAGE } from '@reverbdotcom/commons/src/cms/components/cms_page_cards';
import relatedBuyingGuide from './related_buying_guide';
import { IUserContext, withUserContext } from '@reverbdotcom/commons/src/components/user_context_provider';
import gql from 'graphql-tag';

import { Item2BuyingGuideData } from '../schemas/rql';
import { MParticleEventName } from '@reverbdotcom/commons/src/elog/mparticle_types';
import { trackEvent } from '@reverbdotcom/commons/src/elog/mparticle_tracker';

interface IProps extends IUserContext {
  listing: Item2BuyingGuideData.Fragment;
}

const COMPONENT_NAME = 'Item2BuyingGuide';

export const Item2BuyingGuideFragment = gql`
  fragment Item2BuyingGuideData on Listing {
    _id
    make
    model
    categories {
      _id
      slug
    }
  }
`;

export class Item2BuyingGuide extends React.Component<IProps, null> {
  trackView() {
    trackEvent({
      componentName: COMPONENT_NAME,
      eventName: MParticleEventName.ComponentView,
    });
  }

  componentDidMount() {
    if (this.props.listing) {
      this.trackView();
    }
  }

  buyingGuideSlug() {
    const { listing } = this.props;
    if (!listing) return null;

    return relatedBuyingGuide(
      listing.make,
      listing.model,
      listing.categories,
      this.props.user,
    );
  }

  render() {
    const slug = this.buyingGuideSlug();
    if (!slug) return null;

    return (
      <CmsPageCards
        pageFields={[
          { pageSource: CMS2_PAGE, slug },
        ]}
        layoutSection="sidebar"
      />
    );
  }
}

export default withUserContext(Item2BuyingGuide);
